import { Navigate } from "react-router";
import { MEMBER_TOKEN_KEY } from "../common/authSession";

/** Private app routes: member JWT only (guestToken does not grant access). */
const PrivateRoute = ({ children, redirectPath }) => {
  return localStorage.getItem(MEMBER_TOKEN_KEY) ? (
    <>{children}</>
  ) : (
    <Navigate to={redirectPath || "/"} replace />
  );
};

export default PrivateRoute;